export enum AlertLevel {
    CRITICAL,
    WARNING,
    INFO
}
